
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';
import LoginForm from './components/LoginForm';
import RegistrationForm from './components/RegistrationForm';
import SetPassword from './components/SetPassword';
import AdminRoutes from './GlobalFiles/Routes/AdminRoutes/AdminRoutes';
import ProviderRoutes from './GlobalFiles/Routes/ProviderRoutes/ProviderRoutes';
import PatientRoutes from './GlobalFiles/Routes/PatientRoutes/PatientRoutes';
import axios from "axios";
import EditRolePermission from "./components/AdminUser/EditRolePermission";
import VendorRoutes from "./GlobalFiles/Routes/VendorRoutes/VendorRoutes";


const App = () => {   

    useEffect(() => {
        // Configure Axios defaults
        const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
 
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
        //axios.defaults.baseURL = "http://localhost:8000"; // Replace with your Laravel backend URL
        axios.defaults.baseURL = `${API_BASE_URL}`;

        axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;
        axios.defaults.withCredentials = true;
      }, []);

    const getUserRole = () => localStorage.getItem('role');
    
    return (
        <ThemeProvider theme={theme}>
            <Router>
                <Routes>
                    <Route path="/" element={<LoginForm />} />
                    <Route path="/register" element={<RegistrationForm />} />
                    <Route path="/set-password" element={<SetPassword />} />
                    <Route path="/admin-user/*" element={<AdminRoutes />} />
                    <Route path="/provider-user/*" element={<ProviderRoutes />} />
                    <Route path="/patient-user/*" element={<PatientRoutes />} />
                    <Route path="/vendor-user/*" element={<VendorRoutes />} />                  
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
            </Router>
        </ThemeProvider>
    );
};

export default App;
